const isDev = process.env.NODE_ENV !== 'production';

const logger = {
    log: (message?: any, ...args: any[]) => {
        if (isDev) console.log(message, ...args);
    },
    error: (message?: any, ...args: any[]) => {
        if (isDev) console.error(message, ...args);
    },
    warn: (message?: any, ...args: any[]) => {
        if (isDev) console.warn(message, ...args);
    }
};

export default logger;
